import {inject, ref} from "vue";

import {usePage} from "@inertiajs/vue3";
import Cookies from "js-cookie";

export function initDeveloperMode(app) {
  const isDeveloper = ref(Cookies.get("developer") === "YES");

  function toggleDeveloperMode() {
    const page = usePage();
    if (page?.props?.environmentConfig?.isDevelop !== true) {
      Cookies.remove("developer");
      return;
    }

    isDeveloper.value = !isDeveloper.value;
    if (isDeveloper.value) {
      Cookies.set("developer", "YES");
      console.log("Developer mode: ON");
    } else {
      Cookies.remove("developer");
      console.log("Developer mode: OFF");
    }
  }

  app.provide("$developerMode", isDeveloper);
  globalThis.toggleDeveloperMode = toggleDeveloperMode;
}

export function useDeveloperMode() {
  const page = usePage();
  if (page?.props?.environmentConfig?.isDevelop !== true) {
    return ref(false);
  }

  return inject("$developerMode");
}
